import React, { Component } from 'react';
import { withRouter } from 'utilities';
import { useAuth } from 'auth_context';
import { Loading } from 'components';

class JoinRequestsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			requests: [],
			acting: null, // request id currently being approved/rejected
		};
	}

	componentDidMount() {
		this.fetchRequests();
	}

	fetchRequests = async () => {
		this.setState({ loading: true });
		const res = await this.props.auth.authFetch('/api/join_requests/');
		const data = await res.json();
		this.setState({ requests: data.requests || [], loading: false });
	};

	respond = async (requestId, action) => {
		this.setState({ acting: requestId });
		const res = await this.props.auth.authFetch(`/api/join_requests/${requestId}/respond/`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ action }),
		});
		const data = await res.json();

		if (data.success) {
			this.setState(prev => ({
				requests: prev.requests.filter(r => r.id !== requestId),
				acting: null,
			}));
		} else {
			alert(data.error || 'Action failed.');
			this.setState({ acting: null });
		}
	};

	render() {
		const { loading, requests, acting } = this.state;
		const isAdmin = this.props.auth.user?.is_admin;

		if (loading) return <Loading loading />;

		return (
			<div className="org-info-container">
				<div style={{ display: 'flex', alignItems: 'baseline', gap: '18px' }}>
					<h1 style={{ margin: 0 }}>Join Requests</h1>
					{isAdmin && (
						<span style={{ fontStyle: 'italic', color: 'rgba(220,220,220,0.7)', fontSize: '20px', position: 'relative', bottom: '2px' }}>
							[Admin]
						</span>
					)}
				</div>

				<div className="admin-org-list">
					{requests.length === 0 && (
						<p style={{ color: 'rgba(255,255,255,0.5)' }}>No pending requests.</p>
					)}

					{requests.map(req => (
						<div key={req.id} className="admin-org-card">
							<div className="admin-org-row">
								<div className="admin-org-info">
									<span className="admin-org-name">
										{req.user.name || req.user.username}
									</span>
									<span className="admin-org-meta">
										{req.user.email} · wants to join <strong>{req.org.name}</strong>
									</span>
								</div>
								<div className="admin-org-actions">
									<button
										className="admin-org-btn admin-org-btn--save"
										onClick={() => this.respond(req.id, 'approve')}
										disabled={acting === req.id}
									>
										{acting === req.id ? '…' : 'Approve'}
									</button>
									<button
										className="admin-org-btn admin-org-btn--delete"
										onClick={() => this.respond(req.id, 'reject')}
										disabled={acting === req.id}
									>
										{acting === req.id ? '…' : 'Reject'}
									</button>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	}
}

const JoinRequests = props => {
	const auth = useAuth();
	return <JoinRequestsPage {...props} auth={auth} />;
};

export default withRouter(JoinRequests);
